<h1>Mon Compte</h1>
<div class="dealer-card" >
  <div class="dealer-image">
    <div class = "image-container">
      @if (dealerImagesFolder?.length! < 1 && dealer.imagesFilenames?.length! > 0) {
        <p class="spinner">
          <mat-spinner style="margin:0 auto;"  [diameter]="35"></mat-spinner>
        </p>
      }
      <img mat-card-image [src]="(currentImage != undefined) ? currentImage : 'assets/images/autodeal_logo.png'" alt="Dealer Image">
      <div class = "img-arrow-container">
        <button [disabled]="!(dealerImagesFolder != undefined && dealerImagesFolder!.length > 1)" mat-button (click)="prevImage();$event.stopPropagation()" class="pic-arrow-left"><mat-icon>arrow_back_ios</mat-icon></button>
        <button [disabled]="!(dealerImagesFolder != undefined && dealerImagesFolder!.length > 1)" mat-button (click)="nextImage();$event.stopPropagation()" class="pic-arrow-right"><mat-icon>arrow_forward_ios</mat-icon></button>
      </div>

      @if ((dealerImagesFolder != undefined && dealerImagesFolder!.length > 0)) {
        <div class = "img-counter">
          {{ currentImageIndex + 1 }}/{{ dealerImagesFolder!.length }}
        </div>
      }
    </div>
    <div class = "image-thumbs">

      @for (file of dealerImagesFolder  ; track file; let i = $index) {
        <div class="image-thumb"
          [style.border-color]=" (i===currentImageIndex) ? 'yellow': 'white'">
          <!-- <p class="spinner" *ngIf="dealerImagesFolder?.length! < 1 && dealer.imagesFilenames?.length! > 0">
          <mat-spinner style="margin:0 auto;"  [diameter]="35"></mat-spinner>
        </p>  -->
        <!-- <img mat-card-image [src]= "(currentImage != undefined) ? currentImage : 'assets/images/car_image_holder.png'" alt="Car Image">
        -->
        <!-- <img src= "assets/images/car_image_holder.png" alt="Car Image"> -->
        <img mat-card-image
          [src]="(dealerImagesFolder.length! > 0) ? getImage(i) : 'assets/images/autodeal_logo.png'" alt="Dealer Image"
          (click)="selectImage(i)"
          >
        </div>
      }
    </div>

    <div class="car-pic-upload">
      <label for="files" class="btn"> Ajouter photo </label>
      <input id="files" type="file" accept="image/*" multiple (change)="uploadImage(dealer.username,$event); $event.stopPropagation()" />
    </div>

    <div class="dealer-infos">

      <div class="dealer-infos-block">

        @if (dealer !== undefined && dealer.firstName !== '') {
          <h6>
            <p>Fournisseurs préférés:
              @for (prov of dealer.favoriteProviderIds; track prov; let i = $index) {
                <b>
                  <a [routerLink]="['/provider/public']" [queryParams]="{id: prov}"> {{prov}}</a>,&nbsp;
                </b>
              }
            </p>
            <br />
            <p>
              <label>Avis clients: </label>
              @for (r of dealer.ratingsSummary!.indicators; track r; let i = $index) {
                <span>
                  @if (r===1) {
                    <mat-icon>star</mat-icon>
                  }
                  @if (r!==1) {
                    <mat-icon> {{r===0?'star_outlined':'star_half'}}</mat-icon>
                  }
                </span>
              }
              <b>{{ dealer.ratingsSummary.average.toFixed(2)}} </b>
              <mat-icon (click)="showDetails = !showDetails" cdkOverlayOrigin #trigger="cdkOverlayOrigin">info</mat-icon>
              <ng-template
                cdkConnectedOverlay
                [cdkConnectedOverlayOrigin]="trigger"
                [cdkConnectedOverlayOpen]="showDetails">
                <div class="ratings-details">
                  <h6><mat-icon>star</mat-icon><mat-icon>star</mat-icon><mat-icon>star</mat-icon><mat-icon>star</mat-icon><mat-icon>star</mat-icon>({{dealer.ratingsSummary.counts[4]}})</h6>
                  <h6><mat-icon>star</mat-icon><mat-icon>star</mat-icon><mat-icon>star</mat-icon><mat-icon>star</mat-icon><mat-icon>star_outlined</mat-icon>({{dealer.ratingsSummary.counts[3]}})</h6>
                  <h6><mat-icon>star</mat-icon><mat-icon>star</mat-icon><mat-icon>star</mat-icon><mat-icon>star_outlined</mat-icon><mat-icon>star_outlined</mat-icon>({{dealer.ratingsSummary.counts[2]}})</h6>
                  <h6><mat-icon>star</mat-icon><mat-icon>star</mat-icon><mat-icon>star_outlined</mat-icon><mat-icon>star_outlined</mat-icon><mat-icon>star_outlined</mat-icon>({{dealer.ratingsSummary.counts[1]}})</h6>
                  <h6><mat-icon>star</mat-icon><mat-icon>star_outlined</mat-icon><mat-icon>star_outlined</mat-icon><mat-icon>star_outlined</mat-icon><mat-icon>star_outlined</mat-icon>({{dealer.ratingsSummary.counts[0]}})</h6>
                </div>
              </ng-template>
              ({{ getRatingsTotalCount()}} avis)
            </p>
            <p>Id: <a [routerLink]="['/provider/public']" [queryParams]="{id: dealer.username}"> <b>{{dealer.username}}</b></a> , Statut: <b>{{dealer.status}}</b></p>
            <p>Type de vendeur: <b>{{dealer.dealerType}}</b></p>
            <p>Nom: <b> {{dealer.civility}} {{dealer.firstName}}, {{dealer.lastName}}</b></p>
            <p>Lieu de résidence: <b> {{dealer.cityResident}}, {{getCountryByCode(dealer.countryResident).name}}</b>
            &nbsp;
            <span class = "mini-flag">
              <img  mat-card-image src="assets/images/country-flags/{{dealer.countryResident}}.png" alt="{{dealer.countryResident}}">
            </span>
          </p>
          <p>Pays d'origine: <b>{{getCountryByCode(dealer.countryOrigin).name}}</b>
          &nbsp;
          <span class = "mini-flag">
            <img  mat-card-image src="assets/images/country-flags/{{dealer.countryOrigin}}.png" alt="{{dealer.countryOrigin}}">
          </span>
        </p>
        <p>Email: <b> {{dealer.email}}</b></p>
        <p>Telephone: <b> +{{dealer.phoneNumber.code}}&nbsp;{{dealer.phoneNumber.number}}</b></p>
        <p>Entreprise: <b>{{dealer.businessName}}, {{dealer.businessType}}</b></p>
        <p>Membre dépuis: <b>{{dateFormat(dealer.created)}}</b></p>
      </h6>
    }

  </div>
  <br />

  <mat-divider></mat-divider>

  <mat-divider></mat-divider>
  <br />

  <div class="seller-actions">

    <div>
      <button class="simple-button" mat-button matTooltipPosition="above" matTooltip="Update dealer details" (click)="openDealerEditDialog();$event.stopPropagation()" >
        Editer<mat-icon>edit</mat-icon>
      </button>
    </div>

    @if (!dealer.partner) {
      <div>
        <button class="simple-button" mat-button matTooltipPosition="above" matTooltip="Add keep offer" (click)="openNewKeepOfferDialog();$event.stopPropagation()" >
          Devenir partenaire <mat-icon>domain</mat-icon>
        </button>
      </div>
    }

    <!--
    <div>
      <button class="simple-button" mat-button matTooltipPosition="above" matTooltip="Share">
        Partager<mat-icon>share</mat-icon>
      </button>
    </div>

    <div>
      <button class="simple-button" mat-button matTooltipPosition="above" matTooltip="Publish" (click)="updateCarStatus(dealer.username, dealer.status);$event.stopPropagation()" >
        {{ getCarStatusAction(dealer.status) }} <mat-icon [style.color]="dealer.status === 'LISTED' ? '#008000':'#ff0000'"> {{ dealer.status === 'LISTED' ? 'public_off' : 'public' }}</mat-icon>
      </button>
    </div> -->
  </div>

  <!--
  <mat-divider></mat-divider>

  <div class="seller-actions">

    <div>
      <button class="cta-button-buy" mat-button matTooltipPosition="above" matTooltip="Update offer details" (click)="openProviderOfferDialog(dealer.username, CarBusinessLine.BUY);$event.stopPropagation()" >
        Mettre en vente<mat-icon>add</mat-icon>
      </button>
    </div>

    <div>
      <button class="cta-button-rent" mat-button matTooltipPosition="above" matTooltip="Update offer details" (click)="openProviderOfferDialog(dealer.username, CarBusinessLine.RENT);$event.stopPropagation()" >
        Mettre en location<mat-icon>add</mat-icon>
      </button>

    </div>
  </div>
  -->

</div>

</div>

<div class="dealer-data">

  <mat-accordion multi>

    @if (dealer.partner) {
      <mat-expansion-panel expanded>
        <mat-expansion-panel-header>
          <mat-panel-title>
            <!-- <h4>Offre pour entretien <span>({{dealer.keepOffer == undefined ? 0 : 1}}) </span></h4>
            <button *ngIf="canAddNewKeepOffer()"
              class="simple-button-keep"  mat-button (click)="openNewKeepOfferDialog();$event.stopPropagation()">
              <mat-icon>add</mat-icon> Nouvelle
            </button> -->
            <h4>Offre de services <span> </span></h4>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div class="dealer-data-section">
          <app-keep-offers
            [objectSource]="objectSource"
            [businessLine]="CarBusinessLine.KEEP"
            [enableNew]="false">
          </app-keep-offers>
        </div>
      </mat-expansion-panel>
    }

    @if (dealer.jobs != undefined && dealer.partner) {
      <mat-expansion-panel [expanded]="true">
        <mat-expansion-panel-header>
          <mat-panel-title>
            <h4> Prestations (jobs) <span>({{dealer.jobs.length}}) </span></h4>
            <button class="simple-button" mat-button (click)="openJobDialog(dealer.keepOffer.offerId, '');$event.stopPropagation()">
              <mat-icon>add</mat-icon>Nouvelle
            </button>
          </mat-panel-title>
        </mat-expansion-panel-header>
        @if ((dealer.jobs.length >= 0)) {
          <app-jobs
            [objectSource]="objectSource"
            [offerId] = "$safeNavigationMigration(dealer.keepOffer?.offerId)!"
            [enableNew]="false"
            >
          </app-jobs>
        }
      </mat-expansion-panel>
    }
    <!--
    <mat-expansion-panel [expanded]="false">
      <mat-expansion-panel-header>
        <mat-panel-title>
          <h4>Contrats client <span *ngIf="dealer.customerContracts.length >= 0">({{dealer.customerContracts.length}}) </span></h4>
          <button class="simple-button-keep" mat-button (click)="openNewContractDialog(dealer.username);$event.stopPropagation()">
            <mat-icon>add</mat-icon>Nouveau
          </button>
        </mat-panel-title>
      </mat-expansion-panel-header>

      <app-contracts
        *ngIf="(dealer.providerContracts.length >= 0)"
        [objectSource]="objectSource"
        [transactionRole]="TransactionRole.CUSTOMER"
        [dealerId]="dealer.username"
        [enableNew]="false">
      </app-contracts>
    </mat-expansion-panel>

    <mat-expansion-panel [expanded]="false">
      <mat-expansion-panel-header>
        <mat-panel-title>
          <h4>Contrats provider <span *ngIf="dealer.providerContracts.length >= 0">({{dealer.providerContracts.length}}) </span></h4>
          <button class="simple-button-keep" mat-button (click)="openNewContractDialog(dealer.username);$event.stopPropagation()">
            <mat-icon>add</mat-icon>Nouveau
          </button>
        </mat-panel-title>
      </mat-expansion-panel-header>

      <app-contracts
        *ngIf="(dealer.providerContracts.length >= 0)"
        [objectSource]="objectSource"
        [transactionRole]="TransactionRole.PROVIDER"
        [dealerId]="dealer.username"
        [enableNew]="false">
      </app-contracts>
    </mat-expansion-panel>
    -->
  </mat-accordion>
</div>
</div>








<div class="customer-account">
  <mat-accordion multi>
    <!--
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title>
          <h5>Changer mot de passe</h5>
        </mat-panel-title>
      </mat-expansion-panel-header>

      <form [formGroup]="passwordRecoverForm" >

        <mat-form-field>
          <mat-label>Ancien</mat-label>
          <input type="password" matInput formControlName="oldPassword">
        </mat-form-field>
        &nbsp;&nbsp;&nbsp;
        <mat-form-field>
          <mat-label>Nouveau </mat-label>
          <input type="password" matInput formControlName="newPassword">
        </mat-form-field>
        &nbsp;&nbsp;&nbsp;


        <button class="simple-button" mat-button [disabled]="!passwordRecoverForm.valid" type="submit" (click)="submitPasswordUpdateForm()" >
          <mat-icon>lock_reset</mat-icon>Changer
        </button>
        <div style="color: orange">{{( authFeedback$ | async) }}</div>

      </form>

    </mat-expansion-panel> -->

    <!--
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title>
          <h5>Mes Messages </h5>

        </mat-panel-title>
      </mat-expansion-panel-header>
      <button mat-button (click)="refreshMessages()"><mat-icon>refresh</mat-icon></button>
      <div >
        <mat-list *ngIf='dealer != null'>
          <mat-list-item
            *ngFor="let message of dealer!.messages; index as i">
            <span matListItemTitle>From: {{ message.senderName }} ({{ message.senderEmail }}) </span>
            <span matListItemLine>Message: {{ message.body }} </span>
            <span matListItemLine>Telephone: ({{message.senderPhoneNumber.code}})  {{message.senderPhoneNumber.number }} </span>
            <span matListItemLine>Date: {{ dateFormat(message.created) }} </span>

          </mat-list-item>
        </mat-list>
        <br />
      </div>
    </mat-expansion-panel>  -->


    <!-- <mat-expansion-panel>
    <mat-expansion-panel-header>
      <mat-panel-title>
        <h5>Changer Mot de Passe</h5>
      </mat-panel-title>

    </mat-expansion-panel-header>

    <form [formGroup]="passwordRecoverForm" >
      <mat-form-field>
        <input type="password" matInput placeholder="Old Password" formControlName="oldPassword">
      </mat-form-field>
      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      <mat-form-field>
        <input type="password" matInput placeholder="New Password" formControlName="newPassword">
      </mat-form-field>

      <p style="color: orange">{{( authFeedback$ | async) }}</p>

      <div class="button">
        <button mat-button [disabled]="!passwordRecoverForm.valid" type="submit" (click)="submitPasswordUpdateForm()" >Change Password</button>
      </div>
    </form>

  </mat-expansion-panel> -->
</mat-accordion>

</div>






